import { render, staticRenderFns } from "./TerrasIndigenas.vue?vue&type=template&id=f0d578d6&lang=pug"
import script from "./TerrasIndigenas.vue?vue&type=script&lang=js"
export * from "./TerrasIndigenas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports